var render = function render(_c,_vm){return _c('path',{attrs:{"fill-rule":"nonzero","d":"M15 5h2.25c.97 0 1.75.78 1.75 1.75v10.5c0 .97-.78 1.75-1.75 1.75H6.75C5.78 19 5 18.22 5 17.25V15H2.75C1.78 15 1 14.22 1 13.25V2.75C1 1.78 1.78 1 2.75 1h10.5c.97 0 1.75.78 1.75 1.75V5zm-2 0V3H3v10h2V6.75C5 5.78 5.78 5 6.75 5H13zM7 7v10h10V7H7z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }